import axios from 'src/api/Api';
import {
    SETS_INVENTORY_EXPORT_SUCCESS,
    SETS_INVENTORY_EXPORT_FAILURE,
} from '../actions';

import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

const buildQueryString = (params) =>
    Object.entries(params)
        .filter(([, value]) => value !== undefined && value !== null && value !== '')
        .map(
            ([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join('&');

export const buildSetsInventoryExportUrl = (baseSiteId, payload = {}) => {
    const queryString = buildQueryString({ allocated: false, ...payload });
    const baseUrl = `occ/v2/${baseSiteId}/inventory/sets/export`;

    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

export default function* setsInventoryExport(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');
    const url = buildSetsInventoryExportUrl(baseSiteId, action.payload);

    try {
        const result = yield axios.get(url, { responseType: 'blob' }).then((response) => response.data);
        yield put({
            type: SETS_INVENTORY_EXPORT_SUCCESS,
            payload: result,
        });
    } catch (error) {
        logUiErrorToBackend(error, { apiEndPoint: url });
        yield put({
            type: SETS_INVENTORY_EXPORT_FAILURE,
            payload: { error: errorHandler('503') },
        });
    }
}